module.exports = "/build/ww.js";
